/** @format */

export const LOGIN_ADMIN_REQUEST = "LOGIN_ADMIN_REQUEST";
export const LOGIN_ADMIN_SUCCESS = "LOGIN_ADMIN_SUCCESS";
export const LOGIN_ADMIN_FAILURE = "LOGIN_ADMIN_FAILURE";
export const REGISTER_ADMIN_REQUEST = "REGISTER_ADMIN_REQUEST";
export const REGISTER_ADMIN_SUCCESS = "REGISTER_ADMIN_SUCCESS";
export const REGISTER_ADMIN_FAILURE = "REGISTER_ADMIN_FAILURE";
// export const LOGOUT_ADMIN_REQUEST = "LOGOUT_ADMIN_REQUEST";
// export const LOGOUT_ADMIN_SUCCESS = "LOGOUT_ADMIN_SUCCESS";
// export const LOGOUT_ADMIN_FAILURE = "LOGOUT_ADMIN_FAILURE";
export const ADD_CLASS_SECTION = "ADD_CLASS_SECTION";
export const ADD_TEACHER_SUBJECT = "ADD_TEACHER_SUBJECT";
export const FILTER_TEACHERS = "FILTER_TEACHERS";
export const LOGOUT_ADMIN = "LOGOUT_ADMIN";
export const DELETE_DATA = "DELETE_DATA";
export const EDIT_TEACHERS_DATA = "EDIT_TEACHERS_DATA";
export const CHANGE_PAGE_NO = "CHANGE_PAGE_NO";
export const CREATE_PAGES = "CREATE_PAGES";
